(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.hotel.controller-esg
  (:require
   [clojure.edn :as edn]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.hotel.controller :as controller]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))


(defn ->ui-data
  [{:keys [dynamic-data report-data map-topo] :as props}]
  (merge (controller/->ui-data props)
         {:energy-performance-counts (edn/read-string (get-in dynamic-data [:energy-performance-counts]))
          :energy-performance-status (report-ctl/rich-content props :energy-performance-status)
          :green-building-certification-sqm-pct (get-in dynamic-data [:green-building-certification-sqm-pct])
          :green-building-certification-certified-count (get-in dynamic-data [:green-building-certification-certified-count])
          :green-building-certification-total-count (get-in dynamic-data [:green-building-certification-total-count])
          :green-building-status (report-ctl/rich-content props :green-building-status)
          :eu-taxonomy-alignment (get-in dynamic-data [:eu-taxonomy-alignment])
          :eu-taxonomy-plan (report-ctl/rich-content props :eu-taxonomy-plan)
          :eu-taxonomy-notes (report-ctl/rich-content props :eu-taxonomy-notes)
          :other-esg-development (report-ctl/rich-content props :other-esg-development)}
  ))
